const AlertFrequency = Object.freeze({
  FIFTEEN_MINUTES: 'Fifteen_Minutes',
  HALF_HOUR: 'Half_Hour',
  HOURLY: 'Hourly',
  DAILY: 'Daily',
  MONTHLY: 'Monthly',
  TWICE_DAILY: 'Twice_Daily',
  WEEKLY: 'Weekly',
  TWO_HOURS: 'Two_Hours',
  THREE_HOURS: 'Three_Hours',
  FOUR_HOURS: 'Four_Hours',
  SIX_HOURS: 'Six_Hours',
  EIGHT_HOURS: 'Eight_Hours',
  TWELVE_HOURS: 'Twelve_Hours'
})
export default AlertFrequency
// RESERVE BELOW
export type AlertFrequencyStrings = typeof AlertFrequency[keyof typeof AlertFrequency]
